var _excluded = ["escapeHTML", "transformItems", "hitComponent", "bannerComponent"],
  _excluded2 = ["hit", "index"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { createHitsComponent } from 'instantsearch-ui-components';
import React, { createElement, Fragment, useMemo } from 'react';
import { useHits } from 'react-instantsearch-core';
// @MAJOR: Move default hit component back to the UI library
// once flavour specificities are erased
function DefaultHitComponent(_ref) {
  var hit = _ref.hit;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      wordBreak: 'break-all'
    }
  }, JSON.stringify(hit).slice(0, 100), "\u2026");
}
var HitsUiComponent = createHitsComponent({
  createElement: createElement,
  Fragment: Fragment
});
export function Hits(_ref2) {
  var escapeHTML = _ref2.escapeHTML,
    transformItems = _ref2.transformItems,
    _ref2$hitComponent = _ref2.hitComponent,
    HitComponent = _ref2$hitComponent === void 0 ? DefaultHitComponent : _ref2$hitComponent,
    BannerComponent = _ref2.bannerComponent,
    props = _objectWithoutProperties(_ref2, _excluded);
  var _useHits = useHits({
      escapeHTML: escapeHTML,
      transformItems: transformItems
    }, {
      $$widgetType: 'ais.hits'
    }),
    hits = _useHits.hits,
    banner = _useHits.banner,
    sendEvent = _useHits.sendEvent;
  var itemComponent = useMemo(function () {
    return function (_ref3) {
      var hit = _ref3.hit,
        index = _ref3.index,
        itemProps = _objectWithoutProperties(_ref3, _excluded2);
      return /*#__PURE__*/React.createElement("li", _extends({
        key: hit.objectID
      }, itemProps), /*#__PURE__*/React.createElement(HitComponent, {
        hit: hit,
        sendEvent: sendEvent
      }));
    };
  }, [HitComponent, sendEvent]);
  var bannerComponent = BannerComponent === false ? function () {
    return null;
  } : BannerComponent;
  var uiProps = {
    hits: hits,
    sendEvent: sendEvent,
    itemComponent: itemComponent,
    banner: banner,
    bannerComponent: bannerComponent
  };
  return /*#__PURE__*/React.createElement(HitsUiComponent, _extends({}, props, uiProps));
}